module.exports = __webpack_public_path__ + "assets/mobile.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.svg
// module id = L8Ki
// module chunks = 1